module.exports = __webpack_public_path__ + "media/Literatur- Apotheke_Kulturium.bc89bb8a.mp3";